<!--        TODO: clea up; Make these aligning logics dynamic; -->
<mat-card
    class="mat-small-card"
    [ngStyle]="
        smallCardContainerStyle && {
            'text-align': hasBPS ? 'left' : 'center',
            'padding-left': hasBPS ? '14px' : '10px',
            'min-height': hasBPS ? '120px' : '134px'
        }
    "
>
    <card-controller-panel
            [cardInfo]="cardControllerInfo"
    ></card-controller-panel>
    <div (click)="clickCard()" class="{{ pointerClass }}">
<!--        TODO: Uses dynamic solution to these hasBPS flag-->
        <p
            class="small-card-title  {{ pointerClass }}"
            [style.font-size.px]="titleFontSize"
            [ngStyle]="{ margin: hasBPS ? '0' : '0 5px' }"
        >
            {{ title }}
        </p>
        <spin-loader *ngIf="!isDataReady" [type]="'spinner'"></spin-loader>
        <div *ngIf="isDataReady && hasData">
            <div
                *ngIf="hasData && hasAccess && mainValue != ''"
                class="smallcard-top-area {{ pointerClass }}"
                [ngStyle]="{ display: hasBPS ? 'flex' : 'block' }"
            >
                <label
                    class="small-card-number {{ pointerClass }}"
                    [style.font-size.px]="mainValueFontSize"
                    [ngStyle]="{
                        'padding-bottom': hasBPS ? '0' : '10px',
                        width: hasBPS && mainValue.length > 7 ? '70%' : ''
                    }"
                >
                    {{ mainValue
                    }}<span class="small-card-units">
                        {{ unit }}
                    </span>
                </label>
                <div *ngIf="subTitle">
                    <span class="subTitle">{{ subTitle }}</span>
                </div>

                <div
                    *ngIf="comparisonValue"
                    class="comparisonLine {{ pointerClass }}"
                    [ngStyle]="{ 'margin-top': hasBPS ? '2px' : '' }"
                >
                    <div
                        class="svgContainerData"
                        style="display: inline-block"
                        [innerHtml]="svgData"
                    ></div>
                    <div style="display: inline-block; padding-left: 5px">
                        <label
                            id="sm-card-6-comparison"
                            class="small-card-comparison-text  {{ pointerClass }}"
                            [ngStyle]="{ color: faIconColor }"
                        >
                            &ensp;{{ comparisonValue }}
                        </label>
                    </div>
                </div>
                <div *ngIf="!comparisonValue" class="comparisonLine">
                    <!-- Compensate for missing space for null comparisons -->
                    <div class="svgContainerData" style="display: inline-block"></div>
                </div>
            </div>
        </div>
    </div>
    <div
        *ngIf="bottomCardData.length > 0 && hasData && isDataReady"
        class="bottom-card-data {{ hasBPS ? 'bottom-card-data-withBPS' : '' }}"
    >
        <table>
            <tr *ngFor="let bottomCardDatum of bottomCardData">
                <td class="value-td">
                    <div
                        class="{{
                            bottomCardDatum.hasAccess && showPointer
                                ? 'hyperlinked-bottomcard-value'
                                : ''
                        }}"
                        *ngIf="bottomCardDatum.isHyperlinked"
                        (click)="clickBottomCardItem(bottomCardDatum)"
                    >
                        {{ bottomCardDatum.value }}
                    </div>
                    <div *ngIf="!bottomCardDatum.isHyperlinked">
                        {{ bottomCardDatum.value }}
                    </div>
                </td>
                <td class="description-td">
                    {{ bottomCardDatum.description }}
                </td>
            </tr>
        </table>
    </div>

    <div
        *ngIf="bottomTable.length > 0 && hasData && isDataReady && hasAccess"
        class="card-table-data"
    >
        <table width="100%">
            <tr>
                <td>
                    <table width="98%">
                        <tr class="card-table-head-tr">
                            <th
                                *ngFor="let thItem of bottomTable[0].tdList"
                                [ngStyle]="thItem.headerStyle"
                            >
                                {{ thItem.headerTitle }}
                            </th>
                        </tr>
                    </table>
                </td>
            </tr>
            <tr>
                <td>
                    <div class="small-card-table-body-area">
                        <table width="100%">
                            <tr *ngFor="let rowData of bottomTable">
                                <td
                                    class="table-data-td"
                                    [ngStyle]="tdItem.style"
                                    *ngFor="let tdItem of rowData.tdList"
                                >
                                    <div
                                        class="{{
                                            tdItem.hasAccess ? 'hyperlinked-bottomcard-value' : ''
                                        }}"
                                        *ngIf="tdItem.isHyperlinked"
                                        (click)="clickTableCardItem(tdItem)"
                                    >
                                        {{ tdItem.value }}
                                    </div>
                                    <div *ngIf="!tdItem.isHyperlinked">
                                        {{ tdItem.value }}
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>
                </td>
            </tr>
        </table>
    </div>
    <div class="no-data-message-area" *ngIf="(!hasData && isDataReady) || !hasAccess">
        <no-data-screen [noDataType]="noDataType"> </no-data-screen>
    </div>
</mat-card>
